import {storageData} from "../utils/storage";

export async function downloadFileRequest(API_URL, today, startDate, endDate) {
    const token = storageData('token').getValue()

    try {
        const response = await fetch(`${API_URL}markets/download-file/${startDate}/${endDate}`, {
                method: 'GET',
                headers: {
                    "Authorization": "Token " + token,
                },
            });

        if (!response.ok) {
            console.error('Error fetching data:', response);
            throw new Error('API request failed');
        }

        const blob = await response.blob();

        const contentDisposition = response.headers.get('Content-Disposition');
        const filenameMatch = contentDisposition ? contentDisposition.match(/filename="([^"]+)"/) : null;
        const filename = filenameMatch ? filenameMatch[1] : `sensormatic-fbox-from-${startDate}-to-${endDate}.xlsx`;

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();

        setTimeout(() => window.URL.revokeObjectURL(url), 1000);

    } catch (error) {
        console.error('Error:', error);
    }
}